<template>
  <div class="col-xs-10 col-sm-10 grid_div" id="grid_right_div">
    <!--<div id="flushBtn"></div>-->
    <div id="contentDiv">
      <div class="head_title">
        <div class="head_title_font">班级管理&gt;</div>
      </div>
      <div class="body_content">
        <!-- 导出模态框（Modal） -->
        <div class="modal fade" id="export_myModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
          <div class="modal-dialog">
            <div class="modal-content export_content">
              <div class="modal-header export_header">
                导出主体班级
              </div>
              <div class="modal-body">
                <div class="export_class">
                  <label style="margin: 10px 0 10px 5px;">时间筛选:</label>
                  <input type="text" name="chooseStartDate" id="chooseStartDate" v-model="clazzInfo.startDate" style="width: 120px;" readonly>
                  &nbsp;&nbsp;—&nbsp;&nbsp;
                  <input type="text" name="chooseEndDate" id="chooseEndDate" v-model="clazzInfo.endDate" style="width: 120px;" readonly>
                </div>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-default" @click="exportOverClass()">确定</button>
                <button type="button" class="btn btn-default" data-dismiss="modal">返回</button>
              </div>
            </div>
          </div>
        </div>


        <div class="situation_all_div">
          <div class="situation_one_div" @click="initClassDataByStatus()">
            <span><!--{{numFlag.allNum}}-->{{statusInfo.type1}}</span>个全部
            <div class="situation_one_img"><img src="../assets/img/right/clazz/sousuo.png"/></div>
          </div>
          <div class="situation_one_div" @click="initClassDataByStatus(1)">
            <span><!--{{numFlag.noOpenClass + numFlag.openingClass+numFlag.endClass}}-->{{statusInfo.type2}}</span>个已发布
            <div class="situation_six_img"><img src="../assets/img/right/clazz/sousuo.png"/></div>
          </div>
          <div class="situation_one_div" @click="initClassDataByStatus(0)">
            <span><!--{{numFlag.noPublish}}-->{{statusInfo.type3}}</span>个未发布
            <div class="situation_two_img"><img src="../assets/img/right/clazz/sousuo.png"/></div>
          </div>
          <div class="situation_one_div" @click="initClassDataByStatus(1, 0)">
            <span><!--{{numFlag.noOpenClass}}-->{{statusInfo.type4}}</span>个未开班
            <div class="situation_three_img"><img src="../assets/img/right/clazz/sousuo.png"/></div>
          </div>
          <div class="situation_one_div" @click="initClassDataByStatus(1, 1)">
            <span><!--{{numFlag.openingClass}}-->{{statusInfo.type5}}</span>个开班中
            <div class="situation_four_img"><img src="../assets/img/right/clazz/sousuo.png"/></div>
          </div>
          <div class="situation_one_div" @click="initClassDataByStatus(1, -1)">
            <span><!--{{numFlag.endClass}}-->{{statusInfo.type6}}</span>个已结业
            <div class="situation_five_img"><img src="../assets/img/right/clazz/sousuo.png"/></div>
          </div>
        </div>
        <div class="classList_div">
          <!--<label style="margin: 10px 0 10px 5px;">时间筛选:</label>
          <input type="text" name="chooseStartDate" id="chooseStartDate" v-model="clazzInfo.startDate" style="width: 120px;" readonly>
          &nbsp;&nbsp;—&nbsp;&nbsp;
          <input type="text" name="chooseEndDate" id="chooseEndDate" v-model="clazzInfo.endDate" style="width: 120px;" readonly>-->
          <div class="searcharea">
            <label style="margin: 10px 0 10px 5px;">时间筛选:</label>
            <input id="startDate" data-vv-as="开始日期" class="form-control new_date" size="16" type="text" name="startDate" readonly v-model="searchParams.startDate"/>
            <span class="spanRed"></span>
            ——
            <input id="endDate" data-vv-as="结束日期" class="form-control new_date" size="16" type="text" name="endDate" readonly v-model="searchParams.endDate"/>
            <input class="form-control" placeholder="请输入班级名称"  v-model="searchParams.name"/>
            <button type="button" class="btn btn-default btn_option" @click="searchParams.page==1;searchParams.rows=10;pageClick()">查询</button>
            <button type="button" class="btn btn-default" @click="refresh()">重置</button>
          </div>
          <div class="exportClass">
            <button type="button" class="btn btn_option" @click="addClassMsg()">新建班级</button>
            <button type="button" class="btn btn-default btn_option btn_export" @click="exportOverClass()">导出班次统计</button>
            <button type="button" class="btn btn-default btn_option btn_export" @click="exportClazzUnit()">导出课程安排</button>
          </div>
          <table class="table table-striped table-bordered">
            <thead>
            <tr>
              <th width="5%">#</th>
              <th width="20%">班级名称</th>
              <th width="20%">开班时间</th>
              <th width="20%">发布状态</th>
              <th width="20%">开班状态</th>
              <th width="15%">操作</th>
            </tr>
            </thead>
            <tbody>
<!--            <tr v-for="(classOne, index) in classList" :key="index" @click="optionFlag='details';clazzId=classOne.id;publishStatus=classOne.checkStatus;classStatus=classOne.status;creatorId=classOne.creatorId;saveDataIntoStorage()">-->
            <tr v-for="(classOne, index) in classList" :key="index">
              <td width="5%">
<!--                {{index+1}}-->
                <input type="checkbox" name="clazzCheck" :value="classOne.id" :key="classOne.id">
              </td>
              <td width="20%" style="cursor: pointer;" @click="optionFlag='details';clazzId=classOne.id;publishStatus=classOne.checkStatus;classStatus=classOne.status;creatorId=classOne.creatorId;saveDataIntoStorage()">{{classOne.name}}</td>
              <td width="20%">{{classOne.startDate}}——{{classOne.endDate}}</td>
              <td width="20%">{{classOne.checkStatus | turnPublishStatusWord}}</td>
              <td width="20%" v-if="classOne.checkStatus == 0"> —— </td>
              <td width="20%" v-else>
                {{classOne.status | turnClassStatusWord}}
                <div class="graduate_pic" v-if="classOne.status == 1" @click.stop="graduate(classOne.name, classOne.id)" data-toggle="tooltip" data-placement="bottom" title="结业"></div>
              </td>
              <td width="15%" style="padding-left: 4%;"><!--:class="{show_edit_pic: classOne.checkStatus == 0}"-->
                <div class="edit_pic" :class="{show_edit_pic: classOne.status != -1}" @click="optionFlag='edit';clazzId=classOne.id;publishStatus=classOne.checkStatus;classStatus=classOne.status;creatorId=classOne.creatorId;saveDataIntoStorage()" data-toggle="tooltip" data-placement="bottom" title="编辑"></div>
                <div class="delete_pic" :class="{show_delete_pic: classOne.checkStatus == 0 || classOne.status == -1}" @click="clazzId=classOne.id;publishStatus=classOne.checkStatus;classStatus=classOne.status;deleteClass()" data-toggle="tooltip" data-placement="bottom" title="删除"></div>
                <!--<div class="details_pic" :class="{show_details_pic: classOne.checkStatus == 1 || classOne.status == -1}" @click="optionFlag='details';clazzId=classOne.id;publishStatus=classOne.checkStatus;classStatus=classOne.status;creatorId=classOne.creatorId;saveDataIntoStorage()" data-toggle="tooltip" data-placement="bottom" title="详情"></div>-->
              </td>
            </tr>
            </tbody>
          </table>
          <!--分页-->
          <div id="page-break">
            <ul>
              <li v-if="searchParams.page>1">
                <a v-on:click="searchParams.page--,pageClick()">上一页</a>
              </li>
              <li v-if="searchParams.page==1">
                <a class="banclick">上一页</a>
              </li>
              <li v-for="item in indexs" v-bind:class="{'active':searchParams.page==item}">
                <a v-on:click="searchParams.page=item, pageClick()">{{item}}</a>
              </li>
              <li v-if="searchParams.page!=searchParams.all">
                <a v-on:click="searchParams.page++,pageClick()">下一页</a>
              </li>
              <li v-if="searchParams.page==searchParams.all">
                <a class="banclick">下一页</a>
              </li>
              <li><a>共<i>{{searchParams.all}}</i>页</a></li>
              <div class="jumpbox">
                <input type="number" class="jumppage" />
                <a class="jumpbtn" v-on:click="pageSkip()">跳转</a>
              </div>

              <div class="btn-group dropup">
                <button type="button" class="btn btn-default dropdown-toggle" data-toggle="dropdown">每页<span>{{searchParams.rows}}</span>条
                  <span class="caret"></span>
                </button>
                <ul class="dropdown-menu" role="menu">
                  <li><a href="#" @click="searchParams.page==1;searchParams.rows=10;pageClick()">10条</a></li>
                  <li><a href="#" @click="searchParams.page==1;searchParams.rows=15;pageClick()">15条</a></li>
                  <li><a href="#" @click="searchParams.page==1;searchParams.rows=20;pageClick()">20条</a></li>
                </ul>
              </div>

            </ul>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
  import {schoolAxios} from '../main';
  import {getContentSize} from './mainView';

  import dictionaryData from '../json/dictionary';

  export default {
    name: "class",
    data() {
      return {
        clazzId : '',
        publishStatus : 0,
        classStatus : 0,
        //操作标识
        optionFlag: '',
        creatorId: '',
        //班级发布状态标识
        check_status: dictionaryData.check_status,
        //班级状态标识
        clazz_status: dictionaryData.clazz_status,
        //班级数据列表
        classList: [],

        clazzInfo:{
          startDate:'',
          endDate:'',
        },

        classInfoEditFlag:true,

        numFlag: {
          allNum: 0,
          // havePublish:0,
          noPublish: 0,
          noOpenClass: 0,
          openingClass: 0,
          endClass: 0
        },
        havePublish:0,
        //教务领导
        leaderUserCode: this.$store.state.leaderUserCode,
        userCode: this.$store.state.userCode,

        token: this.$store.state.access_token,
        hrefExport:this.$store.state.serviceBase+"resources/",


        //今日日期
        timeDate: '',

        searchParams: {
          cur: 1,
          all: 0,
          rows: 10,
          startDate:'',
          endDate:'',
          ids:''
        },

        statusInfo:{
          type1: 0,//全部
          type2: 0,//已发布
          type3: 0,//未发布
          type4: 0,//未开班
          type5: 0,//开班中
          type6: 0//已结业
        },

        //当前页
        // cur: 1,

        //总页数
        // all: 50


        //每页条数

      }
    },
    filters: {
      turnPublishStatusWord(value){
        let this_ = this;
        if(dictionaryData.check_status && value){
          value = dictionaryData.check_status[value];
        }
        return value;
      },
      turnClassStatusWord(value){
        let this_ = this;
        if(dictionaryData.clazz_status && value){
          value = dictionaryData.clazz_status[value];
        }
        return value;
      }
    },
    created: function () {

    },
    mounted: function () {
      let this_ = this;
      this.$nextTick(function () {
        getContentSize();
        this_.searchParams.page = 1;
        this_.initClassData();
        this_.dateDefault();
        this_.getClassCountsByStatus();
      });
    },
    // updated: function () {
    //   let this_ = this;
    //   //日期
    //   this_.dateDefault();
    // },
    watch: {

    },

    methods: {
      /**
       * 加载班级数据
       */
      initClassData(){
        let this_ = this;
        console.log(this_.searchParams)
        if(this_.userCode.indexOf(this_.leaderUserCode) != -1){
          schoolAxios({
            method: 'get',
            url: 'clazz/findAllPage',
            params:this_.searchParams /*{
              checkStatus: this_.searchParams.checkStatus,
              status: this_.searchParams.status,
              page:this_.cur,
              rows: this_.rows
            }*/
          }).then(function (response) {
            //console.info(response);
            let data = response.data;
            if(data.success){
              this_.classList = data.list;
              // this_.searchParams.page = data.page;
              this_.searchParams.all = data.totalPage;
              // this_.countNum();
            }
          });
        }else {
          schoolAxios({
            method: 'get',
            url: 'clazz/findPage',
            params:this_.searchParams/* {
              checkStatus: this_.searchParams.checkStatus,
              status: this_.searchParams.status,
              page:this_.cur,
              rows: this_.rows
            }*/
          }).then(function (response) {
            //console.info(response);
            let data = response.data;
            if (data.success) {
              this_.classList = data.list;
              // this_.searchParams.page = data.page;
              this_.searchParams.all = data.totalPage;
              // this_.countNum();
            }
          });
        }
      },
      /**
       * 统计班级状态
       */
      getClassCountsByStatus(){
        let this_=this;
        if(this_.userCode.indexOf(this_.leaderUserCode) != -1){
          schoolAxios({
            method: 'get',
            url: 'clazz/getAllCountStatus',
            params:{}
          }).then(function (response) {
            let data = response.data;
            if(data.success){
              this_.statusInfo = data.data;
            }
          });
        }else {
          schoolAxios({
            method: 'get',
            url: 'clazz/getCountStatus',
            params:{}
          }).then(function (response) {
            let data = response.data;
            if (data.success) {
              this_.statusInfo = data.data;
            }
          });
        }
      },
      refresh(){
        let this_=this;
        this_.searchParams.name = '';
        this_.searchParams.startDate = '';
        this_.searchParams.endDate = '';
        this_.searchParams.ids = '';
        const checkboxes = document.getElementsByName("clazzCheck");
        for (let i = 0; i < checkboxes.length; i++) {
          checkboxes[i].checked = false
        }
        this_.searchParams.page=1;
        this_.searchParams.rows=10;
        this_.pageClick();
      },
      /**
       * 分页
       */
      /* btnClick(num){
         if(num!=this.cur){
           this.cur=num;
         }
       },*/
      pageClick(){
        let this_=this;
        //console.log('现在是'+this.cur+'页');
        this_.initClassData();
      },
      pageSkip(){
        var maxPage = this.searchParams.all;
        var skipPage = Number(document.getElementsByClassName("jumppage")[0].value);
        //console.log(typeof skipPage);
        if(!skipPage){
          alert("请输入跳转页码");
          return;
        }else if(skipPage<1 || skipPage>maxPage){
          alert("您输入的页码超过页数范围了！");
          return;
        }else{
          this.searchParams.page=skipPage;
          // this.btnClick(skipPage);
          this.pageClick();
        }
      },
      setCurrentPageRows(){
        let this_=this;
        this_.initClassData();
      },
      /**
       * 结业
       * */
      graduate(className, classId){
        let this_=this;
        (className+"，确定现在结业吗？").showConfirm(function () {
          schoolAxios({
            // method: 'get',
            url:'clazz/updateStatus',
            params: {
              "id":classId
            }
          }).then(function (response) {
            let data = response.data;
            if(data.success){
              this_.initClassData();
            }
          });
        })
      },
      /**
       * 通过状态查询班级列表
       */
      initClassDataByStatus(checkStatus, status){
        this.searchParams.checkStatus = checkStatus;
        this.searchParams.status = status;
        this.searchParams.page = 1;
        this.initClassData();
        /*let this_ = this;
        if(this_.userCode.indexOf(this_.leaderUserCode) != -1){
          schoolAxios({
            method: 'get',
            url: 'clazz/findAllPage',
            params: {
              checkStatus: checkStatus,
              status: status,
              page:this_.cur,
              rows: '15'
            }
          }).then(function (response) {
            console.info(response);
            let data = response.data;
            if (data.success) {
              this_.classList = data.list;
              this_.cur = data.page;
              this_.all = data.totalPage;
            }
          });
        }else {
          schoolAxios({
            method: 'get',
            url: 'clazz/findListPage',
            params: {
              checkStatus: checkStatus,
              status: status,
              page:this_.cur,
              rows: '15'
            }
          }).then(function (response) {
            console.info(response);
            let data = response.data;
            if (data.success) {
              this_.classList = data.list;
              this_.cur = data.page;
              this_.all = data.totalPage;
            }
          });
        }*/
      },

      /**
       * 班级状态计数
       */
      countNum(){
        let this_ = this;
        this_.numFlag = {
          allNum: 0,
          havePublish:0,
          noPublish: 0,
          noOpenClass: 0,
          openingClass: 0,
          endClass: 0
        };
        for(let i=0; i<this_.classList.length; i++){
          this_.numFlag.allNum += 1;
          let data = this_.classList[i];
          if(data.checkStatus == 0){//未发布
            this_.numFlag.noPublish += 1;
          } else {
            if(data.status == 0){//已发布
              this_.numFlag.noOpenClass += 1;
            }else if(data.status == 1){
              this_.numFlag.openingClass += 1;
            }else if(data.status == -1){
              this_.numFlag.endClass += 1;
            }
          }
        }
      },
      /**
       * 增加班级数据
       */
      addClassMsg(){
        let this_ = this;
        //保存或修改

        this_.$store.set("clazzId", '');
        this_.$store.set("publishStatus", 0);
        this_.$store.set("classStatus", 0);
        this_.$store.set("classInfoEditFlag", 1);

        //路由跳转
        this_.$router.push({
          name: 'OpenClassMessage',
        });
      },
      /**
       * 点击修改或编辑时查看详情数据
       */
      saveDataIntoStorage(){
        let this_ = this;
        try{
          e.stopPropagation();//非IE浏览器
        }
        catch(e){
          window.event.cancelBubble = true;//IE浏览器
        }
        if( (this_.optionFlag == 'edit' && this_.classStatus != -1) || (this_.optionFlag == 'details') ){/*this_.optionFlag == 'edit' && this_.publishStatus == 0*/
          //保存或修改

          this_.$store.set("clazzId", this_.clazzId);
          this_.$store.set("publishStatus", this_.publishStatus);
          this_.$store.set("classStatus", this_.classStatus);
          this_.$store.set("classInfoEditFlag", this_.creatorId==this_.$store.state.userId?1:0);
          //路由跳转
          this_.$router.push({
            name: 'OpenClassMessage',/*this_.classStatus==0?'OpenClassMessage':'ClassBasisAfter',
            params: {
              clazzId: this_.clazzId,
              publishStatus: this_.publishStatus,
              classStatus: this_.classStatus
            }*/
          });
        }
      },
      /**
       * 删除班级数据
       */
      deleteClass(){
        let this_ = this;
        try{
          e.stopPropagation();//非IE浏览器
        }
        catch(e){
          window.event.cancelBubble = true;//IE浏览器
        }
        if(this_.publishStatus == 0 || this_.classStatus == -1){
          //执行删除
          "确定是否删除".showConfirm(function () {
            schoolAxios({
              method: 'delete',
              url: 'clazz/delete/'+this_.clazzId,
              params: {}
            }).then(function (response) {
              console.info(response);
              let data = response.data;
              if(data.success){
                this_.initClassData();
              }
            });
          })
        }
      },
      /*查询已发布班级*/
      initPublishedClassData (checkStatus){
        let this_ = this;
        if(this_.userCode.indexOf(this_.leaderUserCode) != -1){
          schoolAxios({
            method: 'get',
            url: 'clazz/findAllList',
            params: {
              checkStatus: checkStatus,
              // status: status
            }
          }).then(function (response) {
            console.info(response);
            let data = response.data;
            if (data.success) {
              this_.classList = data.list;
            }
          });
        }else {
          schoolAxios({
            method: 'get',
            url: 'clazz/findList',
            params: {
              checkStatus: checkStatus,
            }
          }).then(function (response) {
            console.info(response);
            let data = response.data;
            if (data.success) {
              this_.classList = data.list;
            }
          });
        }
      },
      /**
       * 导出已结业班级
       */
      exportOverClass(){
        let this_=this;
        const checkboxes = document.getElementsByName("clazzCheck");
        let ids = new Array()
        for (let i = 0; i < checkboxes.length; i++) {
          if(checkboxes[i].checked){
            ids.push(checkboxes[i].value)
          }
        }
        this_.searchParams.ids = ids.join(',');
        schoolAxios({
          method: 'get',
          url:'clazz/findOverClazzList',
          params: {
            "startDate":this_.searchParams.startDate,
            "endDate":this_.searchParams.endDate,
            "name":this_.searchParams.name,
            "ids":this_.searchParams.ids,
            "access_token":this_.token
          }
        }).then(function (response) {
          if (response.data.success) {
            location.href=this_.hrefExport+response.data.data;
            /*this_.clazzInfo.startDate = startDate;
            this_.clazzInfo.endDate = endDate;*/
          } else{
            console.info(response.data.message)
            response.data.message.showMessage();
          }
        });
        $("#export_myModal").modal("hide");
        /* location.href=this_.hrefExport+'?clazzId='+this_.clazzId+'&access_token='+this_.token;*/
      },
      /**
       * 导出班级课程安排
       */
      exportClazzUnit(){
        let this_=this;
        const checkboxes = document.getElementsByName("clazzCheck");
        let ids = new Array()
        for (let i = 0; i < checkboxes.length; i++) {
          if(checkboxes[i].checked){
            ids.push(checkboxes[i].value)
          }
        }
        this_.searchParams.ids = ids.join(',');
        console.log('-------------------this_.searchParams',this_.searchParams)
        schoolAxios({
          method: 'get',
          url:'clazz/exportClazzUnit',
          params: this_.searchParams
        }).then(function (response) {
          if(response.data.success){
            location.href=this_.hrefExport+response.data.data;
          } else{
            response.data.message.showMessage()
          }
        });
      },
      /**
       * 初始化日期选择框
       */
      dateDefault(){
        let this_ = this;
        let date, nowDate;
        date = new Date();
        nowDate = date.getFullYear() + "-";
        nowDate += (date.getMonth() + 1) + "-";
        nowDate += date.getDate() + " ";
        this_.timeDate = nowDate;
        $('#chooseStartDate').datetimepicker({
          minView: "month",//选择日期后，不会再跳转去选择时分秒
          language: 'zh-CN',
          format: 'yyyy-mm-dd',
          //startDate: this_.timeDate,
          weekStart: 0,
          todayBtn: true,
          clearBtn: true,
          autoclose: true,//选择一个日期后是否立即关闭此选择框
          todayHighlight: true,//高亮当前日期
          startView: 2,// 日期时间选择器打开之后首先显示的视图，默认值为：2，0:hour,1:day,2:mouth,3:year,4:decade
          forceParse: 0,
          showMeridian: 1,
        }).on('hide', function (ev) {
          let value = $("#chooseStartDate").val();
          this_.clazzInfo.startDate = value;
          ev.preventDefault();
          ev.stopPropagation();
        });
        $('#chooseEndDate').datetimepicker({
          minView: "month",
          language: 'zh-CN',
          format: 'yyyy-mm-dd',
          //startDate: this_.timeDate,
          weekStart: 0,
          todayBtn: true,
          clearBtn: true,
          autoclose: true,
          todayHighlight: true,
          startView: 2,
          forceParse: 0,
          showMeridian: 1,
        }).on('hide', function (ev) {
          let value = $("#chooseEndDate").val();
          this_.clazzInfo.endDate = value;
          ev.preventDefault();
          ev.stopPropagation();
        });
        $('.new_date').datetimepicker({
          minView: "month",
          language: 'zh-CN',
          format: 'yyyy-mm-dd',
          //startDate: this_.timeDate,
          weekStart: 0,
          todayBtn: true,
          clearBtn: true,
          autoclose: true,
          todayHighlight: true,
          startView: 2,
          forceParse: 0,
          showMeridian: 1,
        }).on('hide', function (ev) {
          let id = ev.delegateTarget.id;
          if(id == "startDate"){
            let value = $("#startDate").val();
            this_.searchParams.startDate = value;
          }else if(id == "endDate"){
            let value = $("#endDate").val();
            this_.searchParams.endDate = value;
          }
          // else if(id == "new_schedule_startDate"){
          //   let value = $("#new_schedule_startDate").val();
          //   this_.new_schedule.startDate = value;
          // }else{
          //   let id_ = id.substring(id.indexOf("_")+1, id.lastIndexOf("_"));
          //   let index_ = id.substring(id.lastIndexOf("_")+1);
          //   let value = $("#"+id).val();
          //   if(id.indexOf("startDate") != -1){
          //     this_.trainingScheduleList[index_].startDate = value;
          //   }else{
          //     this_.trainingScheduleList[index_].endDate = value;
          //   }
          // }

          ev.preventDefault();
          ev.stopPropagation();
        });
      },
    },
    computed: {
      indexs(){
        var left = 1;
        var right = this.searchParams.all;
        var arr = [];
        if(this.searchParams.all>=7){
          if(this.searchParams.page>4 && this.searchParams.page<this.searchParams.all-3){
            left = this.searchParams.page-3;
            right = this.searchParams.page+3;
          }else if(this.searchParams.page<=4){
            left=1;
            right=7;
          }else{
            left=this.searchParams.all-6;
            right=this.searchParams.all;
          }
        }
        while(left<=right){
          arr.push(left);
          left++;
        }
        return arr;
      }
    }
  }
</script>

<style scoped>
  @import '../assets/css/plugins.css';
  @import "../assets/css/publicStyle.css";

  .situation_all_div {
    position: relative;
    top: 2%;
    width: 100%;
    height: 10%;
  }
  .situation_one_div {
    float: left;
    width: 14%;
    height: 100%;
    color: white;
    font-size: 18px;
    line-height: 75px;
    margin: 0px 1% 1% 1%;
    padding-left: 10px;
    position: relative;
  }
  .situation_one_div:nth-child(1) {
    background-color: #ff4d42;
  }
  /*已发布*/
  .situation_one_div:nth-child(2) {
    background-color: #FF5A58;
  }
  .situation_one_div:nth-child(3) {
    background-color: #fb6b51;
  }
  .situation_one_div:nth-child(4) {
    background-color: #f78a42;
  }
  .situation_one_div:nth-child(5) {
    background-color: #f79851;
  }
  .situation_one_div:nth-child(6) {
    background-color: #eba600;
  }
  .situation_one_div span {
    font-size: 45px;
    font-weight: bold;
  }
  .situation_one_div div {
    float: right;
    width: 25%;
    height: 100%;
    position: absolute;
    right: 0;
    top: 0;
    opacity: 0.6;
  }
  .situation_one_img {
    background-color: #d6483f;
    text-align: center;
  }
  .situation_two_img {
    background-color: #d5604b;
    text-align: center;
  }
  .situation_three_img {
    background-color: #d0793f;
    text-align: center;
  }
  .situation_four_img {
    background-color: #d0844b;
    text-align: center;
  }
  .situation_five_img {
    background-color: #c68f0a;
    text-align: center;
  }
  .situation_six_img {
    background-color: #D6594E;
    text-align: center;
  }

  /*.situation_one_div div img {
    margin-left: 18%;
  }*/


  .classList_div {
    position: relative;
    /*top: 2%;*/
    width: 100%;
    /*height: 86%;*/
    overflow: auto;
  }

  table tr{
    text-align: center;
  }
  table th {
    background: #cccccc;
    text-align: center;
  }
  .table-striped {
    /*background-color: #D7D7D7;*/
  }
  /*.table tbody{
    display: block;
    height: 640px;
    overflow: auto;
  }*/



  .action_pic {
    margin-left: 20%;
  }
  .edit_pic {
    width: 29px;
    height: 22px;
    background-image: url("../assets/img/right/clazz/edit_disabled.png");
    background-size: 100% 100%;
    float: left;
  }
  .delete_pic {
    width: 29px;
    height: 22px;
    background-image: url("../assets/img/right/clazz/delete_disabled.png");
    background-size: 100% 100%;
    float: left;
  }
  .graduate_pic {
    width: 29px;
    height: 22px;
    background-image: url("../assets/img/right/clazz/graduate.png");
    background-size: 100% 100%;
    display: inline-block;
    cursor: pointer;
  }
  .details_pic {
    width: 29px;
    height: 22px;
    background-image: url("../assets/img/right/clazz/details_disabled.png");
    background-size: 100% 100%;
    float: left;
  }
  .show_edit_pic {
    background-image: url("../assets/img/right/clazz/edit_mouseOver.png");
    cursor: pointer;
  }
  .show_delete_pic {
    background-image: url("../assets/img/right/clazz/delete_mouseOver.png");
    cursor: pointer;
  }
  .show_details_pic {
    background-image: url("../assets/img/right/clazz/details_mouseOver.png");
    cursor: pointer;
  }


  .edit_pic,.delete_pic,.details_pic {
    margin: 0 0 0 12%;
  }
  .export_content {
    position: relative;
    left: 30%;
    width: 400px;
  }
  .export_header,.export_class{
    text-align: center;
  }

  /*.edit_pic:hover {
    background-image: url("../assets/img/right/clazz/edit_mouseOver.png");
  }
  .delete_pic:hover {
    background-image: url("../assets/img/right/clazz/delete_mouseOver.png");
  }
  .details_pic:hover {
    background-image: url("../assets/img/right/clazz/details_mouseOver.png");
  }*/
  /*分页*/
  #page-break {
    margin-top: 20px;
    margin-left: 30%;
  }
  #page-break li {
    list-style: none;
  }
  #page-break a {
    border: 1px solid #ddd;
    text-decoration: none;
    float: left;
    padding: 6px 12px;
    /*color: #337ab7;*/
    color: #d44950;
    cursor: pointer}
  #page-break a:hover {
    background-color: #eee;
  }
  #page-break a .banclick {
    cursor: not-allowed;
  }
  #page-break .active a {
    color: #fff;
    cursor: default;
    /*background-color: #337ab7;
     border-color: #337ab7;*/
    background-color: #d44950;
    border-color: #ff6f66;
  }
  #page-break i {
    font-style: normal;
    color: #d44950;
    margin: 0px 4px;
    font-size: 12px;
  }
  #page-break .jumpbox .jumppage {
    border: 1px solid #ddd;
    margin-left: 40px;
    height: 33px;
    width: 40px;
    float: left;}
  #page-break .jumpbox .jumpbtn {
    cursor: pointer;
    margin-left: 10px;
  }
  #page-break .jumpbox .jumpbtn:active {
    color: #d44950;
  }
  .dropdown-menu {
    min-width: 80px;
  }
  .dropdown-menu li {
    margin: 0 0 0 12%;
  }
  .dropdown-toggle {
    color: #d44950;
  }
  .searcharea{
    float: left;
    text-align: left;
    margin: 10px 0px 5px 5px;
  }
  .exportClass{
    float: right;
    text-align: right;
    margin: 10px 0px 5px 5px;
  }
  .searcharea .form-control{
    display: inline-block;
    width: 160px;
  }
</style>



// WEBPACK FOOTER //
// src/components/class.vue